import styled from "styled-components";
import { Select as MuiSelect } from "@material-ui/core";

export const Select = styled(MuiSelect)`
    width: 25rem;
    margin: 0;
`;

export default Select;
